var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-rule"},[_c('fixed-header',{attrs:{"title":"会员说明","black":true,"left":true}}),_c('div',{staticClass:"rule-wrap",domProps:{"innerHTML":_vm._s(_vm.pageData)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }